module.exports = __webpack_public_path__ + "media/images/landings/promotion_2/line_flow_img_pc-2d4a9d924ff1c73b30a786ef554640c7.png";